import { ComponentSearcher } from "@mcleod/components";
import { DbDisplayValue, DisplayType, DisplayValue, ModelRow, StringUtil } from "@mcleod/core";

export class TimelineComponentSearcher extends ComponentSearcher {

    protected override getValuesFromRow(row: ModelRow): string[] {
        let fieldValue = row.get(this.fieldName);
        if (typeof fieldValue === "object") {
            fieldValue.forEach(obj => {
                obj.display_start_date = DisplayValue.getDisplayValue(obj.start_date, DisplayType.DATETIME);
                obj.display_end_date = DisplayValue.getDisplayValue(obj.end_date, DisplayType.DATETIME);
            });
            fieldValue = JSON.stringify(fieldValue);
        } else {
            fieldValue = fieldValue?.toString();
        }
        const result: string[] = [];
        if (StringUtil.isEmptyString(fieldValue) === false) {
            result.push(fieldValue);
            const metadataField = row.getMetadata()?.getFieldFromOutput(this.fieldName)
            metadataField?.dbDisplayValues?.forEach((dbDisplayValue: DbDisplayValue) => {
                if (dbDisplayValue.value.toLowerCase() === fieldValue.toLowerCase())
                    result.push(dbDisplayValue.displayValue);
            });
        }
        return result;
    }

}
